import { reportScriptLoadingError } from '../domain/scriptLoadingError';
export async function lazyLoadProfiler(importProfilerImpl = importProfiler) {
  try {
    return await importProfilerImpl();
  } catch (error) {
    reportScriptLoadingError({
      error,
      source: 'Profiler',
      scriptType: 'module'
    });
  }
}
async function importProfiler() {
  const module = await import(/* webpackChunkName: "profiler" */'../domain/profiling/profiler');
  return module.createRumProfiler;
}
